import request from '../../axios';
import {IPatchBulkStoreAdvertisement} from './usePatchBulkStoreAdvertisement';

export const patchBulkStoreAdvertisement = async (
  payload: IPatchBulkStoreAdvertisement[],
) => {
  const {data} = await request.patch(`/api/v2/store/store-ads`, payload);
  return data;
};
